import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import type { loadEditor, preload } from '@aurigma/design-editor-iframe';
import { environment } from '@src/environments/environment';

// Aurigma global types only include editorUrl.
export interface IFrameEditorApi {
	loadEditor: typeof loadEditor;
	preload: typeof preload;
}

/** Utility class for Customer's Canvas. */
@Injectable({ providedIn: 'root' })
export class CustomersCanvasUtil {
	private readonly window = window;
	private readonly renderer2: Renderer2;

	constructor(
		r2f: RendererFactory2,
		@Inject(DOCUMENT) private readonly document: Document,
	) {
		// eslint-disable-next-line unicorn/no-null
		this.renderer2 = r2f.createRenderer(null, null);
	}

	/**
	 * Load Customer's Canvas editor SDK.
	 * @returns The IframeApi
	 */
	async loadEditorSdk(): Promise<IFrameEditorApi> {
		if (this.window && 'CustomersCanvas' in this.window) {
			return this.window.CustomersCanvas.IframeApi as unknown as IFrameEditorApi;
		}
		return await new Promise((resolve, reject) => {
			const script = this.renderer2.createElement('script') as HTMLScriptElement;
			script.id = 'CcIframeApiScript';
			script.src = environment.customersCanvasSdkUrl;
			script.async = true;
			script.addEventListener('load', () =>
				resolve(this.window.CustomersCanvas.IframeApi as unknown as IFrameEditorApi),
			);
			script.addEventListener('error', (event) => reject(event.error as Error));
			this.renderer2.appendChild(this.document.body, script);
		});
	}
}
